import { actionTypes } from './constants';


const initialState = {
	eventComments: {
		data: [],
		loadingStatus: null
	},
	postEventComment: {
		loadingStatus: null,
		error: undefined
	},
	closeEventLog: {
		loadingStatus: null,
		error: undefined
	},
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_EVENT_COMMENTS:
			return {
				...state,
				eventComments: { ...state.eventComments, ...action }
			};
		case actionTypes.POST_EVENT_COMMENT:
			return {
				...state,
				postEventComment: {
					loadingStatus: action.loadingStatus,
					error: action.error
				}
			};
		case actionTypes.CLOSE_EVENT_LOG:
			return {
				...state,
				closeEventLog: {
					loadingStatus: action.loadingStatus,
					error: action.error
				}
			};
		case actionTypes.CLEAR_STORE:
			return initialState;
		default:
			return state;
	}
};
